/*
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-03-06 14:15:47
 * @LastEditors  : Archer<ahh666@qq.com>
 * @LastEditTime : 2023-06-08 16:17:21
 * @FilePath     : \youxi\youxi\src\request\im.js
 * @Description  : Description
 */

/*
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-03-06 14:15:47
 * @LastEditors  : Archer<ahh666@qq.com>
 * @LastEditTime : 2023-06-08 16:07:28
 * @FilePath     : \youxi\youxi\src\request\im.js
 * @Description  : Description
 */
import { post, get } from "./imRequest";

// 用户
export const userLogin = params => post("/user/login", params);
export const updateUserInfo = params => post("/user/update_user_info", params);
export const refreshToken = params => post("/user/refresh_token", params);

// 会话/群组
export const getAllGroupInfoApi = params => post("/group/group_list_infos", params);
export const getGroupInfoApi = params => post("/group/group_detail", params);
// 通过客服组code创建群聊（groupcode → customercare_group_code）
export const createRoomByCode = params => post("/group/create_group_by_code", params);
// 通过指定客服创建群聊
export const createRoomByCustomercare = params => post("/group/create_group_by_customercare", params);

// 群成员
export const getRoomMembersApi = params => post("/group_member/query_group_member", params);
export const inviteMemberApi = params => post("/group_member/force_intervene", params);
export const transferRoomApi = params => post("/group_member/transfer", params);
export const silenceMemberApi = params => post("/group_member/silencePerson", params);
export const quitRoomApi = params => post("/group_member/quit", params);

// 评价
export const evaluationApi = params => post("/customercare/evaluation_customercare", params);
export const checkEvaluationApi = params => post("/customercare/whether_evaluate", params);

// 文件上传（先上传到 OSS 获得 url，再通过此接口登记）
export const addCommonFileApi = params => post("/shortcut_file/add_common_file", params);
export const getCommonFilesApi = params => post("/shortcut_file/user_common_file", params);

// 客服列表
export const getServiceListApi = params => post("/customercare/customercare_list", params);
// 通讯录
export const getContactListApi = params => post("/customer/contact_list", params);

// 搜索
export const searchCustomerApi = params => post("/search/search_chat_customer", params);
export const searchGroupApi = params => post("/search/search_group", params);
export const searchChatHistoryApi = params => post("/search/search_chat_history", params);

// 全局配置
export const getGlobalConfigApi = params => get("/global_config/get_conf", params);

// 群组操作
export const disbandGroupApi = params => post("/group/disband_group", params);

// 群成员操作 - 置顶/屏蔽
export const markGroupApi = params => post("/group_member/mark_group", params);
export const shieldGroupApi = params => post("/group_member/shield_group", params);
